import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environments';
import { DASHBOARD_ENDPOINTS, CANDIDATE_ENDPOINTS } from 'src/app/globals/app-endpoints';

const uploadApis = [
  DASHBOARD_ENDPOINTS.GENERATE_PRESIGNED_URL,
  CANDIDATE_ENDPOINTS.GENERATE_ATTACHMENT_URL,
];

export const uploadInterceptor: HttpInterceptorFn = (req, next) => {

  const shouldAttachHeader = uploadApis.some(api =>
    req.url.includes(api)
  );

  if (shouldAttachHeader) {
    req = req.clone({
      setHeaders: {
        'x-api-env': environment.apiEnv,
      },
    });
  }

  return next(req);
};